import './App.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Upload() {

  const navigate = useNavigate();
  
  useEffect(() => {

    if (!sessionStorage.getItem("isAdmin")) {
        navigate("/")

    } else {
        // console.log("Logged In")
    }
}, [])


  const notify = () => {toast.success('Data Added!', {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
  }

  const notifyerror = () => {
    toast.error('Data failed to add!', {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      });
  }

    
  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    try {
      const response = await fetch('http://crm.arunexcello.com:3000/convert', {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if(data){
        notify();
      }else(
        notifyerror()
      )
    } catch (err) {
      console.error(err);
    }
  };


  return (
    <div className="App">
      <form id="csv-form" encType="multipart/form-data" onSubmit={handleSubmit}>
        <input type="file" name="csv-file" />
        <button type="submit">Add to Contacts</button>
      </form>
      <div>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />      </div>

    </div>
  );
}

export default Upload;